import { isPtacPathwaySettings } from '@alpinehomeair/common';
import { RootState } from 'app/store';
import { ConfigurationType } from 'data/types';

export function selectActivePtacConfiguration(
  state: RootState
): ConfigurationType | undefined {
  if (!isPtacPathwaySettings(state.project.projectSettings)) return undefined;
  return state.configurations.configurations[state.configurations.activeConfig];
}
